<template>
  <section class="relative overflow-hidden bg-gradient-to-br from-primary-500/10 via-background to-primary-600/5 py-20 md:py-28">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-4xl text-center">
        <h1 class="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl md:text-6xl">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="mt-4 text-lg text-gray-600 dark:text-gray-300 md:text-xl">
          {{ subtitle }}
        </p>
        <div v-if="image" class="mt-10">
          <img
            :src="image"
            :alt="title"
            class="mx-auto rounded-2xl shadow-2xl ring-1 ring-gray-900/10 dark:ring-white/10 max-h-80 object-cover"
          >
        </div>
        <div v-if="ctaText" class="mt-10">
          <UButton
            :to="ctaLink"
            size="xl"
            color="primary"
            variant="solid"
          >
            {{ ctaText }}
          </UButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  subtitle?: string
  image?: string
  ctaText?: string
  ctaLink?: string
}>()
</script>
